import { render, staticRenderFns } from "./BusinessLicence.vue?vue&type=template&id=07c64b16&scoped=true"
import script from "./BusinessLicence.vue?vue&type=script&lang=js"
export * from "./BusinessLicence.vue?vue&type=script&lang=js"
import style0 from "./BusinessLicence.vue?vue&type=style&index=0&id=07c64b16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c64b16",
  null
  
)

export default component.exports